module.exports = "/365FarmNet/dist/cropOverview.a08e955f26567ef998adf522aacdd574.html";